export default {
  SET_LOADING(state, value) {
    state.loading = value
  },

  SET_ERROR(state, error) {
    state.error = error
  },
  SET_ORDER_ERROR_MESSAGE(state, error) {
    state.orderErrorMessage = error
  },
  SET_MESSAGE(state, message) {
    state.message = message
  },
  SET_ORDERS(state, data) {
    state.orders = data.data
  },

  SET_ORDER(state, data) {
    state.order = data.data
  },

  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters }
  },

  SET_PAGINATION(state, data) {
    state.pagination = {
      total: data.total,
      current_page: data.current_page,
      last_page: data.last_page
    }
  }
}